import { Component, inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { FormatKeyValuePipe } from '@pipes/format-key-value.pipe';
import { ITooltipParams } from 'ag-grid-enterprise';
import { TooltipDirective, TooltipPosition } from 'ngx-lib';

@Component({
    selector: 'app-grid-tooltip',
    templateUrl: './grid-tooltip.component.html',
    styleUrls: ['./grid-tooltip.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [TooltipDirective],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [FormatKeyValuePipe]
})
export class GridTooltipComponent {
    public safeTooltipContent!: SafeHtml;
    public currentPosition: TooltipPosition = TooltipPosition.LEFT;
    public tooltipId?: string;
    public left = 0;
    public top = 0;

    private readonly formatPipe = inject(FormatKeyValuePipe);

    agInit(params: ITooltipParams): void {
        const rawValue = params.value;

        let contentToDisplay = '';
        if (rawValue) {
            contentToDisplay = this.formatPipe.transform(rawValue);
        }

        this.safeTooltipContent = contentToDisplay;
    }

    refresh(params: ITooltipParams): boolean {
        this.agInit(params);
        return true;
    }
}
